import { render, staticRenderFns } from "./SmsConversationBox.vue?vue&type=template&id=3cc3d3f2&"
import script from "./SmsConversationBox.vue?vue&type=script&lang=js&"
export * from "./SmsConversationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports